import React from "react";
import Header from "../../components/landingPage/Header";
import Footer from "../../components/landingPage/Footer";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./faq.css";

export default function ControlledAccordions() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="">
      <Header />
      <div className="faq px-6 lg:px-32 xl:px-52 2xl:px-80 pt-32 lg:pt-52 pb-20 font-body">
        <h2 className="text-slate-900 text-2xl md:text-3xl lg:text-4xl text-center pb-10 uppercase">
          FREQUENTLY ASKED QUESTIONS
        </h2>
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          className="border-slate-400 rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className="font-body">
              What is included in the price?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              The prices shown are always per vehicle and include all taxes,
              gratuities, fees, meet & greet services. The maximum numbers of
              passengers and bags which can comfortably fit in each vehicle are
              mentioned under each car class. The number of passengers does not
              affect the price.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Typography className="font-body">
              What is Drivado's cancellation policy?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              All bookings can be cancelled free of charge until 24 hours before
              scheduled pick time. Cancellation would be 100% of the original
              price, if ride is cancelled within 24 hrs of scheduled pick time
              or in case of no show. In cases Cancellation Policy is different,
              it would be notified in advance by us.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography className="font-body">
              How to make amendments to my booking?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              For amendments you can call our customer care at{" "}
              <b>+91 33 4004 5904</b>. Also you can write an email to{" "}
              <b>
                <a href="support@drivado.com">support@drivado.com</a>
              </b>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
          >
            <Typography className="font-body">
              When is my ride charged to my credit card?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              Your credit card is charged instantly at the time of booking. For
              additional service, you will be charged in advance or pay to
              driver directly depending upon circumstances.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel5"}
          onChange={handleChange("panel5")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
          >
            <Typography className="font-body">
              What if my flight or train is not on time?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              Airport pick includes 60 minutes whereas, train station pickups
              includes 15 minutes of complimentary waiting time. We understand
              that there may be issues beyond your control that could lead to
              unexpected delays. By providing your flight or train details upon
              booking, your driver is able to track your arrival time and will
              adjust your pickup time accordingly. If there is a very long delay
              and the driver is not able to wait, we will contact you to work
              out an alternative solution.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel6"}
          onChange={handleChange("panel6")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel6bh-content"
            id="panel6bh-header"
          >
            <Typography className="font-body">
              How to add extra halts to my one-way/transfer booking?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              It is not possible to add extra stops to a one-way/transfer
              booking. If you wish to make one or more stopovers during your
              ride, we recommend an hourly ride booking. Please list the stops
              that you would like to make in the Notes for the driver box.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel7"}
          onChange={handleChange("panel7")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel7bh-content"
            id="panel7bh-header"
          >
            <Typography className="font-body">
              What is to be done if I forget to add my flight/ train number?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              In case you forget to add flight or train number, please call us
              at <b>+91 33 4004 5904</b> or email us at{" "}
              <b>
                <a href="support@drivado.com">support@drivado.com</a>
              </b>
              , so that we shall update the same on your behalf.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel8"}
          onChange={handleChange("panel8")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel8bh-content"
            id="panel8bh-header"
          >
            <Typography className="font-body">
              When is my booking confirmed?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              When booking a service you receive a booking confirmation via
              email directly after you complete the process. Your booking is
              confirmed instantly.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel9"}
          onChange={handleChange("panel9")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel9bh-content"
            id="panel9bh-header"
          >
            <Typography className="font-body">
              How can I be sure that my car is coming?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              Once you have received a booking confirmation via email a car was
              reserved for you. Before your ride you get a text message with all
              driver details, so that you can contact your driver directly, if
              necessary.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel10"}
          onChange={handleChange("panel10")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel10bh-content"
            id="panel10bh-header"
          >
            <Typography className="font-body">
              What happens if I am late?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              As soon as you notice that you might be late, please contact your
              driver directly and notify him about your delay. The driver's
              phone number you find in the email and text message, which you get
              just before the ride. If you forget to notify the driver about
              your delay, he will wait until the included waiting time has
              passed. You will be charged a no-show fee. Delays caused by train
              or flight delays are excluded from this rule (check booking
              conditions to learn about included waiting times and fees for now
              show.)
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel11"}
          onChange={handleChange("panel11")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel11bh-content"
            id="panel11bh-header"
          >
            <Typography className="font-body">
              What do I do when the driver is late?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              Call the driver directly to see where he is. You find his phone
              number in the text message you received before your ride with all
              the driver details. In case there is an issue please contact us at{" "}
              <b>
                <a href="support@drivado.com">support@drivado.com</a>
              </b>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel12"}
          onChange={handleChange("panel12")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel12bh-content"
            id="panel12bh-header"
          >
            <Typography className="font-body">
              What if my flight was cancelled?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              Normal cancelation and booking change rules apply. As soon as you
              know about the flight cancelation you should either cancel or
              change your booking via your Drivado Account or contact us.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel13"}
          onChange={handleChange("panel13")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel13bh-content"
            id="panel13bh-header"
          >
            <Typography className="font-body">
              How does the driver know that I am the right passenger?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              The driver will ask you for your name and some booking details,
              which you have on your booking confirmation. Therefore, please
              keep your booking confirmation handy either as paper printout or
              on your cell phone.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel14"}
          onChange={handleChange("panel14")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel14bh-content"
            id="panel14bh-header"
          >
            <Typography className="font-body">
              What if my destination has changed last minute?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              Please notify the driver about your new destination. Your new
              destination might cause extra costs.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel15"}
          onChange={handleChange("panel15")}
          className="rounded-lg my-2"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="text-secondary" />}
            aria-controls="panel15bh-content"
            id="panel15bh-header"
          >
            <Typography className="font-body">
              Is my payment information safe at Drivado?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="font-body">
              Your payment information is handled with maximum care and is
              secure from unauthorized access. To guarantee that maximum
              security Drivado is working together with a very renown and
              PCI-DSS (Payment Card Industry Data Security Standard) licensed
              payment provider, who complies with strictest security standards.
              flicts as soon as possible.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
      <Footer />
    </div>
  );
}
